(function () {
  'use strict';

  // override indexOf on <IE9
  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (elt /*, from*/) {
      var len = this.length;
      var from = Number(arguments[1]) || 0;
      from = from < 0 ? Math.ceil(from) : Math.floor(from);
      if (from < 0) {
        from += len;
      }
      for (; from < len; from++) {
        if (from in this && this[from] === elt) {
          return from;
        }
      }
      return -1;
    };
  }
  var safeApply = function safeApply(fn) {
    var phase = this.$root.$$phase;
    if (phase === '$apply' || phase === '$digest') {
      if (fn && typeof fn === 'function') {
        fn();
      }
    } else {
      if (fn) {
        this.$apply(fn);
      } else {
        this.$apply();
      }
    }
  };

  // IE 11 Shims
  if (!Array.prototype.includes) {
    // NOTE: NaN will not work with this implementation
    Array.prototype.includes = function (elem) {
      return Object(this).indexOf(elem) > -1;
    };
  }
  if (!String.prototype.includes) {
    String.prototype.includes = function (match) {
      return this.indexOf(match) !== -1;
    };
  }
  var appModule = angular.module('wsLrs', ['wsLrs.filters', 'wsLrs.services', 'wsLrs.directives', 'wsLrs.controllers', 'ngSanitize', 'wsLrs.config', 'wsLrs.cards', 'ui.bootstrap', 'ngAnimate', 'ngFileUpload', 'matchMedia', 'ngCookies', 'ui.sortable', 'wsLrs.constants', 'ui.ace', 'ui.grid', 'react']);
  var outsideModule = angular.module('wsLrs.outside', ['wsLrs.filters', 'ngRoute', 'wsLrs.controllers', 'ngCookies', 'matchMedia', 'wsLrs.constants']);

  /**
   * This function runs repeated config/run options across a module, while still allowing
   * that modules to independently declare its own dependency modules.
   * @param module {angular.module.prototype}
   */
  function prepModule(module) {
    module.config(['$compileProvider', function ($compileProvider) {
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|tel|javascript):/);
    }]).run(['$rootScope', '$location', '$route', 'User', 'UserRoles', 'ChartUtils', function ($rootScope, $location, $route, User, UserRoles, ChartUtils) {
      $rootScope.$safeApply = safeApply;

      // On every route change, check if "requiredPermissions" was registered with the $routeProvider route
      // and if so, check to ensure that the user has the required permission to view those routes.
      $rootScope.$on('$routeChangeStart', function (event, nextRoute) {
        var permissionRestrictedView = nextRoute && nextRoute.requiredPermissions;
        if (permissionRestrictedView) {
          var requiredPermissions = nextRoute.requiredPermissions;
          var userPermissions = UserRoles.getAllRoles(User.get()).map(function (role) {
            return role.id.toLowerCase();
          });

          // See if any of the user's roles intersect with the required roles
          // If not, redirect home
          var insufficientPrivileges = _.intersection(requiredPermissions, userPermissions).length === 0;
          if (insufficientPrivileges) {
            $location.path('/');
          }
        }
        ChartUtils.clearTooltips();
      });
    }]).
    // Keeping old-school behavior of hash URLs, would otherwise break in upgrade to Angular 1.6.x,
    // see https://github.com/angular/angular.js/commit/aa077e81129c740041438688dff2e8d20c3d7b52
    // for details. We should probably eventually just fix this instead.
    config(['$locationProvider', function ($locationProvider) {
      return $locationProvider.hashPrefix('');
    }]).
    // Default route
    config(['$routeProvider', function ($routeProvider) {
      $routeProvider.otherwise({
        resolve: {
          loadRoutes: ['$location', 'CardLoader', '$route', function ($location, CardLoader, $route) {
            // Default path is activity page
            var defaultPath = "/dashboard/default";

            // If it's the empty path, just use the default and go on
            if ($location.path() === '') {
              $location.path(defaultPath);
              return;
            }
            var path = $location.path(),
              isValid = false;

            // See if current location is valid, if so, reload
            angular.forEach($route.routes, function (config, route) {
              if (route === path || config.regexp && config.regexp.test(path)) {
                isValid = true;
                $route.reload();
              }
            });

            // Otherwise, just put them on the default path
            if (!isValid) {
              $location.path(defaultPath);
            }
          }]
        }
      });
    }]).config(['$httpProvider', function ($httpProvider) {
      // Override default cookie and header names for XSRF support in Angular
      $httpProvider.defaults.xsrfCookieName = 'wsXSRFToken';
      $httpProvider.defaults.xsrfHeaderName = 'X-Requested-By';

      // 401 Unauthorized Interceptor - Publishes unauthorized event on $rootScope
      $httpProvider.interceptors.push(['$q', '$rootScope', '$templateCache', 'ShareKeyHelper', function ($q, $rootScope, $templateCache, ShareKeyHelper) {
        return {
          'request': function request(config) {
            config.alreadyCached = $templateCache.get(config.url);
            if (!config.alreadyCached) {
              var shareKey = ShareKeyHelper.getShareKey();
              if (shareKey && shareKey !== "shares") {
                config.params = config.params || {};
                config.params.shareKey = shareKey;
              }
            }
            return config;
          },
          'responseError': function responseError(rejection) {
            if (rejection.status === 401) {
              $rootScope.$broadcast('unauthorized-request');
            }
            return $q.reject(rejection);
          }
        };
      }]);
    }]);
  }
  prepModule(appModule);
  prepModule(outsideModule);
  outsideModule.config(['$routeProvider', function ($routeProvider) {
    $routeProvider.otherwise({
      redirectTo: '/signin'
    });
  }]);
  appModule.config(['$sanitizeProvider', function ($sanitizeProvider) {
    // Add directive as an element that should NOT be sanitized
    $sanitizeProvider.addValidElements({
      htmlElements: ['video-embed', 'ws-safe-click'],
      // HTML tags that have a closing tag
      htmlVoidElements: ['video-embed', 'ws-safe-click'] // HTML tags that do NOT have a closing tag i.e. <video-embed ... />
    }).addValidAttrs(['video-src', 'service', 'ws-ng-click', 'text']);
  }]);
  angular.module('wsLrs.tableau', ['wsLrs.controllers', 'ngCookies', 'ngSanitize', 'wsLrs.config', 'wsLrs.filters', 'wsLrs.constants']).run(['$rootScope', function ($rootScope) {
    $rootScope.$safeApply = safeApply;
  }]);

  // Declare controllers module
  angular.module('wsLrs.controllers', ['ngRoute', 'wsLrs.config', 'wsLrs.services', 'wsLrs.cards']);
  angular.module('wsLrs.directives', ['wsLrs.constants']);
  angular.module('wsLrs.services', ['wsLrs.config']);
  angular.module('wsLrs.cards', ['wsLrs.services', 'wsLrs.config']);
})();
